import * as React from 'react';
import {IControlError, IControlSchema} from '../../../Controls';
import { IDispatcher } from '../../extensions/Dispatcher';
import RangeCalendar, {IRangeCalendarSchema} from './RangeCalendar';
import Calendar, {ICalendarSchema} from './Calendar';

export function createCalendar(schema: IControlSchema, dispatcher: IDispatcher = null, error: IControlError | undefined, visited: boolean): React.ReactElement<any> {
    let sh = schema as ICalendarSchema;
    return sh.finishDate !== null
        ? (<RangeCalendar schema={schema as IRangeCalendarSchema}
            error={error}
            visited={visited}
            dispatcher={dispatcher} />)
        : (<Calendar schema={schema as ICalendarSchema}
            error={error}
            visited={visited}
            dispatcher={dispatcher} />)
}
